import AuthPage from './AuthPage.jsx'

function LoginPage() {
  return <AuthPage mode="login" />
}

export default LoginPage
